// Modules.
import { connect } from 'react-redux';

// Components.
import HeaderMobileLogoBar from './HeaderMobileLogoBar';

// Store.
const mapStateToProps = state => ({
    gvars: state.global.gvars,
});

export default connect(mapStateToProps)(HeaderMobileLogoBar);
